<template>
  <div class="stock-manage tb">
    <custom-tab
      :list="tabData"
      v-model="tabIndex"
    ></custom-tab>
    <manage v-if="tabIndex === 0"></manage>
    <record v-if="tabIndex === 1"></record>
  </div>
</template>

<script>
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import manage from './children/manage.vue';
import record from './children/record.vue';

export default {
  name: 'crmStock',
  mixins: [tableFilterValueMixins],
  components: {
    manage,
    record
  },
  props: {},
  data() {
    return {
      tabIndex: 0,
      showDialog: true
    };
  },
  computed: {
    tabData() {
      return [
        {
          name: this.$t('crm_stock.ku_cun_guan_li'),
          value: 0,
        },
        {
          name: this.$t('crm_stock.ku_cun_ji_lu'),
          value: 1,
        },
      ];
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {

  },
  created() {},
  mounted() {
    this.getFuncView();


  },
};
</script>

<style lang="scss" scoped>
.stock-manage {
  padding-left: 0 !important;


}
</style>
